import { useState, useEffect } from 'react';

export default function HomePage() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });

  const [recentBuyers, setRecentBuyers] = useState<{name: string; city: string; time: string}[]>([]);
  const [showBuyerNotification, setShowBuyerNotification] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({ name: '', city: '', time: '' });
  const [interestedCount, setInterestedCount] = useState(47);
  const [spotsLeft, setSpotsLeft] = useState(8);
  const [showLowStockAlert, setShowLowStockAlert] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const buyersList = [
    { name: 'Dra. Camila S.', city: 'São Paulo, SP', time: '2 min atrás' },
    { name: 'Dra. Fernanda M.', city: 'Rio de Janeiro, RJ', time: '5 min atrás' },
    { name: 'Dr. Lucas R.', city: 'Belo Horizonte, MG', time: '8 min atrás' },
    { name: 'Dra. Juliana P.', city: 'Curitiba, PR', time: '12 min atrás' },
    { name: 'Dra. Amanda L.', city: 'Salvador, BA', time: '15 min atrás' },
    { name: 'Dra. Beatriz C.', city: 'Brasília, DF', time: '18 min atrás' },
    { name: 'Dra. Carolina T.', city: 'Fortaleza, CE', time: '22 min atrás' },
    { name: 'Dr. Rafael N.', city: 'Porto Alegre, RS', time: '25 min atrás' },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Buyer notification - agora diminui as vagas quando aparece
  useEffect(() => {
    let buyerIndex = 0;
    const showNotification = () => {
      setCurrentBuyer(buyersList[buyerIndex]);
      setShowBuyerNotification(true);
      
      // Diminui as vagas quando alguém "compra"
      setSpotsLeft(prev => {
        const newValue = Math.max(2, prev - 1);
        if (newValue <= 5 && !showLowStockAlert) {
          setShowLowStockAlert(true);
          setTimeout(() => setShowLowStockAlert(false), 5000);
        }
        return newValue;
      });
      
      setTimeout(() => setShowBuyerNotification(false), 4000);
      buyerIndex = (buyerIndex + 1) % buyersList.length;
    };

    showNotification();
    const interval = setInterval(showNotification, 15000);
    return () => clearInterval(interval);
  }, [showLowStockAlert]);

  useEffect(() => {
    const interval = setInterval(() => {
      setInterestedCount(prev => prev + Math.floor(Math.random() * 3));
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  // Spots countdown
  useEffect(() => {
    const interval = setInterval(() => {
      setSpotsLeft(prev => {
        const newValue = Math.max(2, prev - 1);
        if (newValue <= 5 && !showLowStockAlert) {
          setShowLowStockAlert(true);
          setTimeout(() => setShowLowStockAlert(false), 5000);
        }
        return newValue;
      });
    }, Math.random() * 120000 + 60000);
    return () => clearInterval(interval);
  }, [showLowStockAlert]);

  const handleCTAClick = () => {
    window.open('https://pay.kiwify.com.br/Qonz2nL', '_blank');
  };

  const scrollToOffer = () => {
    document.getElementById('oferta')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Low Stock Alert - Floating */}
      {showLowStockAlert && (
        <div className="fixed top-24 right-6 z-50 bg-gradient-to-r from-red-600 to-red-700 text-white rounded-2xl shadow-2xl p-6 max-w-sm animate-[slideInRight_0.5s_ease-out] border-2 border-red-400">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0 animate-pulse">
              <i className="ri-alarm-warning-line text-3xl"></i>
            </div>
            <div>
              <p className="font-black text-xl mb-1">⚠️ ATENÇÃO!</p>
              <p className="text-white/95 font-bold">
                Restam apenas <span className="text-2xl text-yellow-300">{spotsLeft} vagas</span> com este preço!
              </p>
              <p className="text-sm text-white/80 mt-2">Após esgotar, o valor volta ao normal</p>
            </div>
          </div>
        </div>
      )}

      {/* Spots Counter - Sticky Top Right */}
      <div className="fixed top-24 left-6 z-50 bg-white rounded-2xl shadow-2xl p-4 border-2 border-red-500 animate-pulse">
        <div className="text-center">
          <p className="text-xs text-gray-600 font-bold mb-1">🔥 VAGAS LIMITADAS</p>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-ping absolute"></div>
            <div className="w-3 h-3 bg-red-500 rounded-full"></div>
            <p className="text-2xl font-black text-red-600">{spotsLeft}</p>
          </div>
          <p className="text-xs text-gray-500 font-semibold">vagas restantes</p>
        </div>
      </div>

      {/* Visitors Counter - Floating Bottom Right */}
      <div className="fixed bottom-24 right-6 z-40 bg-gradient-to-br from-orange-500 to-red-600 text-white rounded-2xl shadow-2xl p-4 border-2 border-orange-300">
        <div className="flex items-center gap-3">
          <div className="relative">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="ri-eye-line text-2xl"></i>
            </div>
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white animate-pulse"></div>
          </div>
          <div>
            <p className="font-black text-2xl">{interestedCount}</p>
            <p className="text-xs text-white/90 font-semibold">pessoas vendo agora</p>
          </div>
        </div>
      </div>

      {/* Buyer Notification Popup */}
      <div className={`fixed bottom-6 left-6 z-50 bg-white rounded-2xl shadow-2xl p-4 max-w-xs transform transition-all duration-500 ${showBuyerNotification ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`}>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
            <i className="ri-check-line text-green-600 text-2xl"></i>
          </div>
          <div>
            <p className="font-bold text-gray-900 text-sm">{currentBuyer.name}</p>
            <p className="text-gray-600 text-xs">{currentBuyer.city}</p>
            <p className="text-green-600 text-xs font-semibold">Acabou de comprar • {currentBuyer.time}</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <img src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/2b963c61d0d70e69e34f1d97e5185f2b.png" alt="FPS Logo" className="h-12 w-auto" />
          <div className="flex items-center gap-4">
            <div className="hidden md:flex items-center gap-3 bg-red-50 px-4 py-2 rounded-full border-2 border-red-200">
              <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-bold text-red-600">Apenas {spotsLeft} vagas restantes!</span>
            </div>
            <button 
              onClick={handleCTAClick}
              className="bg-[#E63946] text-white px-6 py-3 rounded-full font-bold hover:bg-[#d62936] transition-all whitespace-nowrap cursor-pointer shadow-lg animate-pulse"
            >
              🔥 COMPRAR POR R$ 97,00
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section - VSL Style */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1D3557] via-[#457B9D] to-[#1D3557]"></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center">
          <div className="inline-block px-6 py-2 bg-[#E63946] text-white rounded-full font-bold text-sm mb-8 animate-bounce">
            🔥 OFERTA POR TEMPO LIMITADO
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            O Que Separa um Fisioterapeuta Comum
          </h1>
          
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-black text-[#F1FAEE] mb-8 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            De um Fisioterapeuta de Alto Padrão?
          </h2>
          
          <div className="max-w-4xl mx-auto space-y-6 mb-10">
            <p className="text-xl md:text-2xl text-white/95 font-light leading-relaxed">
              Não é sorte. Não é tempo de formado.<br />
              E definitivamente <strong className="text-[#F1FAEE]">não é fazer mais do mesmo</strong>.
            </p>
            
            <p className="text-2xl md:text-3xl text-[#F1FAEE] font-bold leading-relaxed">
              A diferença está em diagnosticar com profundidade,<br />
              tratar com estratégia e gerar resultado real.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
            {/* Fisioterapeuta Comum */}
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border-2 border-red-400/50">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-close-circle-fill text-red-400 text-4xl"></i>
                <h3 className="text-2xl font-bold text-white">Fisioterapeuta Comum</h3>
              </div>
              <ul className="space-y-3 text-left">
                {[
                  "Atende muito… mas cobra pouco",
                  "Executa protocolo… mas não entende o porquê",
                  "Depende de encaminhamento",
                  "Vive inseguro nas decisões clínicas",
                  "Trabalha cansado… e ainda sente que poderia estar fazendo mais"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-close-line text-red-400 text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-white/90 text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Fisioterapeuta de Alto Padrão */}
            <div className="bg-gradient-to-br from-[#F1FAEE] to-white rounded-3xl p-8 border-4 border-[#E63946] shadow-2xl">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-checkbox-circle-fill text-[#E63946] text-4xl"></i>
                <h3 className="text-2xl font-bold text-gray-900">Fisioterapeuta de Alto Padrão</h3>
              </div>
              <ul className="space-y-3 text-left">
                {[
                  "Enxerga o paciente de forma sistêmica",
                  "Interpreta exames com raciocínio clínico",
                  "Conecta sangue, vísceras, coluna e assoalho pélvico",
                  "Entrega resultado que o paciente sente",
                  "Cobra com segurança — porque sabe o valor do que faz"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-[#E63946] text-xl flex-shrink-0 mt-1"></i>
                    <span className="text-gray-900 text-lg font-bold">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 max-w-3xl mx-auto mb-10 border border-white/20">
            <p className="text-2xl md:text-3xl text-white font-bold leading-relaxed">
              A pergunta é simples:<br />
              <span className="text-[#F1FAEE] text-3xl md:text-4xl">Em qual desses dois você quer estar nos próximos 12 meses?</span>
            </p>
          </div>

          <div className="mb-8">
            <img 
              src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/b379405d6fa2d1432c6851978f2e0a5f.jpeg"
              alt="Dra. Viviane Poubel"
              className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-white shadow-2xl"
            />
            <p className="text-white text-lg mt-4 font-semibold">Dra. Viviane Poubel</p>
            <p className="text-white/80">Criadora do Método FPS • +500 profissionais formados</p>
          </div>
          
          <button 
            onClick={scrollToOffer}
            className="bg-[#E63946] hover:bg-[#d62936] text-white text-xl md:text-2xl font-bold px-12 py-5 rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            VER OFERTA ESPECIAL →
          </button>

          <div className="flex items-center justify-center gap-2 mt-6 text-white/80">
            <i className="ri-eye-line"></i>
            <span className="text-sm"><strong>{interestedCount}</strong> pessoas estão vendo esta página agora</span>
          </div>
        </div>
      </section>

      {/* Countdown Timer */}
      <div className="bg-[#E63946] py-4 sticky top-[72px] z-40 shadow-lg">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-center gap-8 flex-wrap">
          <p className="text-white font-bold text-lg">⚡ OFERTA EXPIRA EM:</p>
          <div className="flex gap-4">
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-3xl font-bold text-white">{String(timeLeft.hours).padStart(2, '0')}</div>
              <div className="text-xs text-white/80">HORAS</div>
            </div>
            <div className="text-white text-3xl font-bold">:</div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-3xl font-bold text-white">{String(timeLeft.minutes).padStart(2, '0')}</div>
              <div className="text-xs text-white/80">MIN</div>
            </div>
            <div className="text-white text-3xl font-bold">:</div>
            <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
              <div className="text-3xl font-bold text-white">{String(timeLeft.seconds).padStart(2, '0')}</div>
              <div className="text-xs text-white/80">SEG</div>
            </div>
          </div>
        </div>
      </div>

      {/* Problem Section */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-gray-900">
            Você já se sentiu assim?
          </h2>
          <p className="text-xl text-gray-600 mb-12">Se identificou com pelo menos uma dessas situações?</p>
          
          <div className="space-y-6 text-left">
            {[
              { icon: "😰", text: "Paciente melhora... mas volta com os MESMOS sintomas em poucas semanas" },
              { icon: "😤", text: "Hemograma 'normal', mas você SABE que algo está errado" },
              { icon: "😔", text: "Sensação de estar apagando incêndio, sem resolver a CAUSA RAIZ" },
              { icon: "😣", text: "Frustração de ver que seus protocolos não sustentam resultados DURADOUROS" },
              { icon: "🤯", text: "Você estudou anos, mas ninguém te ensinou a LER o sangue de verdade" }
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-red-50 border-l-4 border-[#E63946] p-6 rounded-lg transform hover:scale-[1.02] transition-transform">
                <span className="text-4xl">{item.icon}</span>
                <p className="text-xl text-gray-800 font-medium">{item.text}</p>
              </div>
            ))}
          </div>
          
          <div className="mt-12 p-8 bg-gradient-to-r from-[#1D3557] to-[#457B9D] rounded-2xl">
            <p className="text-2xl font-bold text-white">
              A verdade é: <span className="text-[#F1FAEE]">o problema não é você.</span>
            </p>
            <p className="text-xl text-white/90 mt-2">
              É que ninguém te ensinou a olhar o SANGUE da forma certa.
            </p>
          </div>
        </div>
      </section>

      {/* What You'll Learn */}
      <section className="py-20 px-6 bg-gradient-to-br from-[#F1FAEE] to-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              O Que Você Vai Aprender
            </h2>
            <p className="text-xl text-gray-600">11 módulos completos que vão transformar sua prática clínica</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { module: "01", title: "Fundamentos do Sangue", desc: "Entenda a base que ninguém te ensinou na faculdade" },
              { module: "02", title: "Nascimento da Hemácia", desc: "A matéria-prima que determina a saúde celular" },
              { module: "03", title: "Hemoglobina Profunda", desc: "Muito além do valor de referência" },
              { module: "04", title: "Oxigenação Tecidual", desc: "Por que seus pacientes não têm energia" },
              { module: "05", title: "RDW - O Alerta Precoce", desc: "O marcador que você está ignorando" },
              { module: "06", title: "Morfologia da Hemácia", desc: "O que a forma das células revela" },
              { module: "07", title: "Leucócitos e Imunidade", desc: "Sistema de defesa e inflamação oculta" },
              { module: "08", title: "Plaquetas e Coagulação", desc: "Sinais de alerta que passam despercebidos" },
              { module: "09", title: "Correlações Clínicas", desc: "Conectando exames com sintomas reais" },
              { module: "10", title: "Casos Clínicos Reais", desc: "Aprenda com pacientes de verdade" },
              { module: "11", title: "Leitura FPS Integrada", desc: "O método completo na prática" },
              { module: "🎁", title: "Aulas Bônus", desc: "Conteúdos exclusivos e atualizações" }
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
                <div className="w-12 h-12 bg-[#E63946] rounded-xl flex items-center justify-center mb-4">
                  <span className="text-white font-bold">{item.module}</span>
                </div>
                <h3 className="font-bold text-xl mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Transformation */}
      <section className="py-20 px-6 bg-gradient-to-br from-[#1D3557] to-[#457B9D]">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white text-center mb-16">
            Sua Transformação Começa Aqui
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-10 border-2 border-red-400">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-close-circle-fill text-red-400 text-4xl"></i>
                <h3 className="text-3xl font-bold text-white">ANTES do FPS</h3>
              </div>
              <ul className="space-y-4">
                {[
                  "Trata sintomas sem entender a causa",
                  "Hemograma 'normal' mas nada melhora",
                  "Recidiva constante dos problemas",
                  "Frustração com resultados temporários",
                  "Insegurança na análise de exames"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-close-line text-red-400 text-2xl flex-shrink-0 mt-1"></i>
                    <span className="text-white/90 text-lg">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="bg-white rounded-3xl p-10 border-4 border-[#F1FAEE] shadow-2xl">
              <div className="flex items-center gap-3 mb-6">
                <i className="ri-checkbox-circle-fill text-[#E63946] text-4xl"></i>
                <h3 className="text-3xl font-bold text-gray-900">DEPOIS do FPS</h3>
              </div>
              <ul className="space-y-4">
                {[
                  "Raciocínio clínico sistêmico afiado",
                  "Interpreta além do valor de referência",
                  "Resultados sustentáveis e duradouros",
                  "Confiança total na análise de exames",
                  "Tratamento que vai na causa raiz"
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-[#E63946] text-2xl flex-shrink-0 mt-1"></i>
                    <span className="text-gray-900 text-lg font-bold">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              +500 Profissionais Já Transformaram Suas Carreiras
            </h2>
            <p className="text-xl text-gray-600">Veja o que estão dizendo</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {[
              {
                name: "Dra. Mariana Silva",
                role: "Fisioterapeuta Pélvica",
                text: "Depois do FPS, eu finalmente entendi por que meus tratamentos não sustentavam. Agora meus resultados são completamente diferentes!"
              },
              {
                name: "Dra. Carla Mendes",
                role: "Nutricionista Funcional",
                text: "O método da Viviane mudou minha forma de atender. Consigo identificar problemas que antes passavam despercebidos."
              },
              {
                name: "Dr. Ricardo Alves",
                role: "Fisioterapeuta",
                text: "Investimento que se pagou no primeiro mês. Meus pacientes percebem a diferença e indicam para outros."
              }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-6 border border-gray-100">
                <div className="flex text-[#E63946] mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 italic mb-4">"{item.text}"</p>
                <div>
                  <p className="font-bold text-gray-900">{item.name}</p>
                  <p className="text-gray-600 text-sm">{item.role}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-[#1D3557] to-[#457B9D] rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-white mb-2">500+</div>
              <p className="text-white/90 text-lg">Profissionais Formados</p>
            </div>
            <div className="bg-gradient-to-br from-[#1D3557] to-[#457B9D] rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-white mb-2">4.9★</div>
              <p className="text-white/90 text-lg">Avaliação Média</p>
            </div>
            <div className="bg-gradient-to-br from-[#1D3557] to-[#457B9D] rounded-2xl p-8 text-center">
              <div className="text-5xl font-bold text-white mb-2">97%</div>
              <p className="text-white/90 text-lg">Taxa de Satisfação</p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Stack - MAIN OFFER */}
      <section id="oferta" className="py-24 px-6 bg-gradient-to-br from-[#1D3557] to-[#0D1B2A]">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-block px-6 py-3 bg-[#E63946] text-white rounded-full font-bold text-lg mb-6 animate-pulse">
              🔥 OFERTA POR TEMPO LIMITADO
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Veja Tudo Que Você Vai Receber
            </h2>
            <p className="text-xl text-white/80">Stack de valor completo para sua transformação</p>
          </div>

          {/* Value Stack Items */}
          <div className="space-y-4 mb-12">
            {/* Item 1 - Curso */}
            <div className="bg-white rounded-2xl p-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-[#E63946] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-video-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900">Curso FPS START Completo</h3>
                  <p className="text-gray-600">11 módulos + aulas bônus • Certificado de 180h</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-gray-400 line-through">R$ 567</p>
              </div>
            </div>

            {/* Item 2 - Acesso */}
            <div className="bg-white rounded-2xl p-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-[#457B9D] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-check-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900">Acesso por 1 Ano Completo</h3>
                  <p className="text-gray-600">Revise quantas vezes quiser durante 12 meses</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-[#E63946]">Incluído</p>
              </div>
            </div>

            {/* Item 3 - Certificado */}
            <div className="bg-white rounded-2xl p-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-[#E63946] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900">Certificado de 180 Horas</h3>
                  <p className="text-gray-600">Reconhecido e válido para seu currículo</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-[#E63946]">Incluído</p>
              </div>
            </div>

            {/* Item 4 - Ebook */}
            <div className="bg-white rounded-2xl p-6 flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-[#457B9D] rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-book-2-line text-white text-3xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-xl text-gray-900">E-book: Tabelas e Correlações</h3>
                  <p className="text-gray-600">Guia completo de referência rápida</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-[#E63946]">Bônus</p>
              </div>
            </div>
          </div>

          {/* Total Value */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 mb-8 border border-white/20">
            <div className="flex items-center justify-between">
              <p className="text-xl text-white font-bold">VALOR NORMAL:</p>
              <p className="text-3xl font-bold text-white line-through">R$ 567,00</p>
            </div>
          </div>

          {/* Final Price Card */}
          <div className="bg-white rounded-3xl p-10 shadow-2xl text-center">
            <p className="text-gray-600 text-lg mb-2">Por tempo limitado...</p>
            <p className="text-gray-500 text-xl line-through mb-2">De R$ 567,00</p>
            
            <div className="mb-6">
              <p className="text-lg text-gray-700 mb-2">Por apenas:</p>
              <div className="flex items-center justify-center">
                <div className="text-center">
                  <div className="inline-block bg-[#E63946] text-white text-sm font-black px-4 py-1 rounded-full mb-2 animate-pulse">
                    🔥 PREÇO PROMOCIONAL — POR TEMPO LIMITADO
                  </div>
                  <p className="text-6xl md:text-7xl font-bold text-[#E63946]">R$ 97,00</p>
                  <p className="text-xl text-gray-500 mt-1">à vista</p>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border-2 border-yellow-400 rounded-xl p-4 mb-3">
              <p className="text-yellow-800 font-black text-lg text-center">
                ⚠️ Este é um preço PROMOCIONAL especial. O valor normal é R$ 567,00.
              </p>
            </div>

            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-4 mb-6">
              <p className="text-green-700 font-bold text-lg">
                💰 Você economiza R$ 470,00 comprando AGORA!
              </p>
            </div>

            <button 
              onClick={handleCTAClick}
              className="w-full bg-[#E63946] text-white px-12 py-6 rounded-full font-bold text-2xl hover:bg-[#D62828] transition-all shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer mb-4 transform hover:scale-105"
            >
              🔥 COMPRAR AGORA POR R$ 97,00
            </button>

            <p className="text-center text-sm font-bold text-[#E63946] mb-4 animate-pulse">
              ⚡ Preço promocional válido apenas enquanto durar esta oferta!
            </p>

            <div className="flex items-center justify-center gap-2 text-gray-600 mb-4">
              <i className="ri-group-line text-[#E63946]"></i>
              <span className="text-sm"><strong>{interestedCount}</strong> pessoas interessadas nesta oferta</span>
            </div>
            
            <div className="flex items-center justify-center gap-6 text-sm text-gray-600 flex-wrap">
              <span className="flex items-center gap-2">
                <i className="ri-shield-check-line text-green-600 text-xl"></i>
                Compra 100% segura
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-time-line text-green-600 text-xl"></i>
                Acesso imediato
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-refresh-line text-green-600 text-xl"></i>
                7 dias de garantia
              </span>
            </div>
          </div>

          {/* Urgency Timer */}
          <div className="mt-8 text-center">
            <p className="text-white text-xl font-bold mb-4">⏰ Esta oferta expira em:</p>
            <div className="flex gap-4 justify-center">
              <div className="bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl">
                <div className="text-4xl font-bold text-white">{String(timeLeft.hours).padStart(2, '0')}</div>
                <div className="text-sm text-white/80">HORAS</div>
              </div>
              <div className="text-white text-4xl font-bold">:</div>
              <div className="bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl">
                <div className="text-4xl font-bold text-white">{String(timeLeft.minutes).padStart(2, '0')}</div>
                <div className="text-sm text-white/80">MIN</div>
              </div>
              <div className="text-white text-4xl font-bold">:</div>
              <div className="bg-white/20 backdrop-blur-sm px-6 py-3 rounded-xl">
                <div className="text-4xl font-bold text-white">{String(timeLeft.seconds).padStart(2, '0')}</div>
                <div className="text-sm text-white/80">SEG</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-3xl p-10 border-2 border-green-200">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-32 h-32 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-fill text-green-600 text-6xl"></i>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Garantia Incondicional de 7 Dias</h3>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Se por qualquer motivo você não ficar satisfeita com o curso, basta enviar um e-mail em até 7 dias e devolvemos <strong>100% do seu investimento</strong>. Sem perguntas, sem burocracia. O risco é todo nosso.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-12">Perguntas Frequentes</h2>
          <div className="space-y-4">
            {[
              {
                q: "Preciso ser fisioterapeuta para fazer o curso?",
                a: "Não! O FPS START é para todos os profissionais da saúde que querem aprender a interpretar exames de sangue com raciocínio clínico funcional: fisioterapeutas, nutricionistas, enfermeiros, médicos, etc."
              },
              {
                q: "Quanto tempo tenho de acesso?",
                a: "Você tem acesso por 1 ano completo ao curso e recebe certificado de 180 horas."
              },
              {
                q: "Como funciona a garantia?",
                a: "Você tem 7 dias de garantia incondicional. Se não gostar, devolvemos 100% do seu dinheiro sem perguntas."
              },
              {
                q: "Quando posso começar?",
                a: "Imediatamente após a confirmação do pagamento! O acesso é liberado na hora."
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl border border-gray-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer"
                onClick={() => setOpenFaq(openFaq === index ? null : index)}
              >
                <div className="flex items-center justify-between p-6">
                  <p className="font-bold text-xl text-gray-900 pr-4">{item.q}</p>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`ri-arrow-${openFaq === index ? 'up' : 'down'}-s-line text-2xl text-[#E63946]`}></i>
                  </div>
                </div>
                {openFaq === index && (
                  <div className="px-6 pb-6">
                    <p className="text-gray-700 text-lg">{item.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 px-6 bg-[#1D3557]">
        <div className="max-w-5xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/b379405d6fa2d1432c6851978f2e0a5f.jpeg" 
                alt="Viviane Poubel"
                className="rounded-3xl shadow-2xl w-full"
              />
            </div>
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
                Não deixe seus pacientes esperando mais tempo
              </h2>
              <p className="text-xl text-white/90 mb-6 leading-relaxed">
                A transformação que você precisa para ter resultados sustentáveis está a um clique de distância.
              </p>
              <p className="text-lg text-white/80 mb-8">
                Te espero dentro do FPS START! 💙<br />
                <span className="font-bold text-2xl text-[#F1FAEE]">Viviane Poubel</span>
              </p>
              <button 
                onClick={handleCTAClick}
                className="inline-flex items-center gap-3 bg-[#E63946] text-white px-8 py-5 rounded-full font-bold text-xl hover:bg-[#D62828] transition-all shadow-xl whitespace-nowrap cursor-pointer w-full justify-center"
              >
                🔥 COMPRAR AGORA POR R$ 97,00
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>
              <p className="text-yellow-300 text-sm text-center mt-3 font-bold animate-pulse">⚡ Preço promocional — não perca esta oportunidade!</p>
              <p className="text-white/60 text-sm text-center mt-1">⏰ Oferta por tempo limitado</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#F1FAEE] py-12 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <img src="https://static.readdy.ai/image/e054c862bb8832d032cf0cf58507f2c7/2b963c61d0d70e69e34f1d97e5185f2b.png" alt="FPS Logo" className="h-14 w-auto mb-4" />
              <p className="text-gray-700 leading-relaxed mb-4">
                Fisioterapia Pélvica Sistêmica
              </p>
              <div className="flex gap-3">
                <a href="https://instagram.com/vivianepoubel" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1D3557] rounded-full flex items-center justify-center hover:bg-[#457B9D] transition-colors cursor-pointer">
                  <i className="ri-instagram-line text-white"></i>
                </a>
                <a href="https://youtube.com/@vivianepoubel" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1D3557] rounded-full flex items-center justify-center hover:bg-[#457B9D] transition-colors cursor-pointer">
                  <i className="ri-youtube-line text-white"></i>
                </a>
                <a href="https://wa.me/556130346179" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-[#1D3557] rounded-full flex items-center justify-center hover:bg-[#457B9D] transition-colors cursor-pointer">
                  <i className="ri-whatsapp-line text-white"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="font-bold text-lg mb-4">Contato</h4>
              <div className="space-y-2 text-gray-700 text-sm">
                <p className="flex items-center gap-2">
                  <i className="ri-mail-line"></i>
                  digitalgev@gmail.com
                </p>
                <p className="flex items-center gap-2">
                  <i className="ri-phone-line"></i>
                  (61) 3034-6179
                </p>
              </div>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Garantia</h4>
              <p className="text-gray-700 text-sm leading-relaxed">
                7 dias de garantia incondicional. Se não gostar, devolvemos 100% do seu investimento.
              </p>
            </div>
          </div>

          <div className="border-t border-gray-300 pt-6 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <p>© 2025 FPS - Dra. Viviane Poubel. Todos os direitos reservados.</p>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#E63946] transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
